const initScrollBtn = function () {
  const scrollBtnEl = document.querySelector('.b-btn_scroll');

  // Если кнопки нет на странице - выходим
  if (!scrollBtnEl) return;

  const scrollBtn = {
    el: scrollBtnEl,
    scrolling: false,

    show: function() {
      if (this.scrolling) return;
      this.el.classList.remove('b-btn_scroll_hidden');
      this.el.classList.add('b-btn_scroll_visible');
    },

    hide: function() {
      if (this.scrolling) return;
      if(this.el.classList.contains('b-btn_scroll_visible')) {
        this.el.classList.add('b-btn_scroll_hidden');
        this.el.classList.remove('b-btn_scroll_visible');
      }
    },

    handleScroll: function() {
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      scrollY > 1000 ? this.show() : this.hide();
    },

    scrollToTop: function() {
      this.scrolling = true;
      this.hide(); // Сразу скрываем кнопку при начале скролла

      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });

      // Возвращаем возможность показывать кнопку после завершения скролла
      var self = this;
      setTimeout(function() {
        self.scrolling = false;
        self.handleScroll(); // Проверяем позицию скролла
      }, 1000);
    },

    addEventListener: function() {
      // Оптимизация скролла с помощью throttle
      var scrollTimeout;
      var self = this;

      var throttledScroll = function() {
        if (!scrollTimeout) {
          scrollTimeout = setTimeout(function() {
            self.handleScroll();
            scrollTimeout = null;
          }, 100);
        }
      };

      window.addEventListener('scroll', throttledScroll);

      // Обработчик клика
      this.el.addEventListener('click', function() {
        self.scrollToTop();
      });
    }
  };

  scrollBtn.addEventListener();
}

// Инициализация при загрузке страницы
document.addEventListener('DOMContentLoaded', function() {
  initScrollBtn();
});
